import { inject, Injectable, signal } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import FormService, { FormDefinition } from './forms.service';
import ClientService, { ClientDoc } from '../services/client.service';
import { NotificationDoc } from '../services/notification.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import ThematiqueService from '../services/thematique.service';
import { NextFormService } from '../services/next-form.service';

@Injectable({
  providedIn: 'root',
})
export default class CurrentFormService {
  formGroup: FormGroup = new FormGroup({});
  public definition = signal<FormDefinition | undefined>(undefined);
  public client = signal<ClientDoc | undefined>(undefined);
  public notification = signal<NotificationDoc | undefined>(undefined);
  public otherFormTodo = signal<FormDefinition[]>([]);
  public pdfUrl = signal<SafeResourceUrl | null>(null);
  private sanitizer = inject(DomSanitizer);
  private thermatiqueService = inject(ThematiqueService);
  public formService = inject(FormService);
  public nextFormService = inject(NextFormService);

  constructor(private clientService: ClientService) {}

  loadForm(formId: string, stepId?: number | null) {
    this.formService.getFormById(formId).subscribe({
      next: (definition) => {
        this.definition.set(definition);
        this.goToStep(stepId || 1);
      },
    });
  }

  goToStep(stepId: number) {
    if (!this.definition()) return;
    this.loadThematiques();

    const step = this.definition()!.steps.find((step) => {
      return step.id == stepId;
    });
    step?.fields.forEach((field) => {
      console.log('adding field : ', field);
      if (field.type === 'input:employee_signatures') {
        this.addField(field.name, new FormControl(''));
      } else if (field.type === 'input:externals') {
        this.addField('input_' + field.name, new FormControl(''));
        this.addField(field.name, new FormArray<FormControl>([]));
      } else if (field.type === 'input:externals_signatures') {
        this.addField(field.name, new FormArray<FormControl>([]));
      } else if (field.type === 'input:checkboxs') {
        this.addField(field.name, new FormArray<FormControl>([]));
      } else if (field.type === 'input:epis') {
        this.addField(field.name, new FormControl([]));
      } else if (field.type === 'input:switch') {
        this.addField(field.name, new FormControl(true));
        if (field.logic && field.logic.Oui) {
          this.addField(field.logic.Oui.name, new FormControl(''));
        }
      } else if (field && field.type === 'input:checkboxs_complexe') {
        this.addField(field.name, new FormArray<FormControl>([]));
        for (let item of field.items) {
          for (let input of item.inputs) {
            this.addField(input.name, new FormControl(''));
          }
        }
      } else if (field && field.type === 'input:checkboxs+size') {
        this.addField(field.name, new FormArray<FormControl>([]));
        for (let [index, item] of field.items.entries()) {
          this.addField(field.name + '_' + index + '_size', new FormControl(''));
        }
      } else if (field && field.type && field.type.startsWith('input:')) {
        this.addField(field.name, new FormControl(null));
      }
    });
  }

  getTitleForCurrentStep(stepId: number) {
    return this.definition()?.steps.find((step) => step.id === stepId)!.title || '';
  }

  getFieldsForStep(stepId: number) {
    const fields = this.definition()?.steps.find((step) => step.id === stepId)!.fields;

    console.log('fields', fields);
    return fields;
  }

  loadThematiques() {
    if (!this.definition() || this.definition()?._id !== 'form:causerie') return;

    const thematiqueId = this.form.get('thematique')?.value.uuid;
    if (thematiqueId) {
      // Load thematique and complete fields : objectifs_contexte contexte pointsabordes

      this.thermatiqueService.getThematique(thematiqueId).subscribe({
        next: (thematique) => {
          if (this.form.get('objectifs_contexte'))
            this.form.get('objectifs_contexte')?.setValue(thematique.objectifs);
          if (this.form.get('contexte')) this.form.get('contexte')?.setValue(thematique.contexte);
          if (this.form.get('pointsabordes'))
            this.form.get('pointsabordes')?.setValue(thematique.points);
        },
      });
      this.thermatiqueService
        .loadPdfFromCouch(this.form.get('thematique')?.value.uuid as any)
        .subscribe({
          next: (blob: any) => {
            const blobUrl = URL.createObjectURL(blob);

            const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
            this.pdfUrl.set(safeUrl);
          },
          error: (err) => console.error(err),
        });
    }
  }

  loadClient(uuid: string) {
    this.clientService.get(uuid).subscribe({
      next: (res) => this.client.set(res),
    });
  }
  get(field: string) {
    return this.formGroup.get(field);
  }

  reset() {
    this.formGroup = new FormGroup({});
    this.client.set(undefined);
    this.nextFormService.reset();
  }

  addField(name: string, control: FormControl | FormArray | Array<any>) {
    this.formGroup.addControl(name, control);
  }

  get value() {
    return this.formGroup.value;
  }

  get form() {
    return this.formGroup;
  }
}
